import { styled } from '@mui/material/styles';
import { CSSProperties } from 'react';

export const HeroSection = styled('section')(({ theme }) => ({
  position: 'relative',
  width: '100vw',
  marginLeft: 'calc(50% - 50vw)',
  marginRight: 'calc(50% - 50vw)',
  marginTop: '-72px',
  height: '250px',
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    height: '500px',
  },
  [theme.breakpoints.up('md')]: {
    height: 'clamp(250px, 46vw, 450px)',
  },
}));

export const heroImageStyle: CSSProperties = {
  objectFit: 'cover',
  objectPosition: 'center 50%',
};

export const HeroOverlay = styled('div')({
  position: 'absolute',
  inset: 0,
  background:
    'linear-gradient(180deg, rgba(1, 47, 91, 0.56) 0%, rgba(1, 47, 91, 0.4) 50%, rgba(1, 47, 91, 0.18) 100%)',
});

export const ContentSection = styled('section')(({ theme }) => ({
  position: 'relative',
  zIndex: 10,
  width: '100vw',
  marginLeft: 'calc(50% - 50vw)',
  marginRight: 'calc(50% - 50vw)',
  backgroundColor: '#f5f6f8',
  padding: '40px 16px',
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    padding: '48px 24px',
  },
}));

export const HeroTitle = styled('h1')(({ theme }) => ({
  maxWidth: '980px',
  margin: '0 auto 20px',
  color: '#1f3150',
  fontWeight: 700,
  lineHeight: 1.25,
  fontSize: '1.4rem',
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem',
  },
}));

export const HeroDescription = styled('p')(({ theme }) => ({
  maxWidth: '980px',
  margin: '0 auto',
  color: '#1f3150',
  fontWeight: 500,
  lineHeight: 1.42,
  fontSize: '0.84rem',
  [theme.breakpoints.up('md')]: {
    fontSize: '1.24rem',
  },
}));
